//  Check documentation here for more details!
//  http://kenwheeler.github.io/slick/
import { updateSliderArrowAppearance } from './helpers';

export const nextArrow = `<button class="slick-next slick-arrow" aria-label="Next" type="button">
                      <svg class="slick-arrow-svg slick-arrow-svg-right light" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 40 40">
                      <g fill="none" fill-rule="evenodd">
                          <circle cx="20" cy="20" r="20" fill="#31363c" stroke="rgba(94, 116, 142, 0.5)"/>
                          <g stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                              <path d="M11.25 5.25L18.842 12 11.25 18.75M18 12L6 12" transform="translate(9 8)"/>
                          </g>
                      </g>
                      </svg>
                      </button>
                      `;

export const prevArrow = `<button class="slick-prev slick-arrow" aria-label="Previous" type="button">
                      <svg class="slick-arrow-svg slick-arrow-svg-left light" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 40 40">
                      <g fill="none" fill-rule="evenodd">
                          <circle cx="20" cy="20" r="20" fill="#31363c" stroke="rgba(94, 116, 142, 0.5)"/>
                          <g stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                              <path d="M5.25 0L12.842 6.75 5.25 13.5M12 6.75L0 6.75" transform="matrix(-1 0 0 1 26.5 13.25)"/>
                          </g>
                      </g>
                      </svg>
                      </button>`;

const initImageCarouselSlider = (slider) => {
  const $slider = slider;
  const slidesToShow = $slider.data('slides-to-show');
  const options = imageCarouselSliderOptions(parseInt(slidesToShow));
  $slider.slick(options);
};
const imageCarouselSliderOptions = (slidesToShow = 2) => {
  const imageCarouselSettings = {
    infinite: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    dots: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: slidesToShow,
        },
      },
    ],
  };
  return imageCarouselSettings;
};

const initProgressBar = (slider) => {
  const $slider = $(slider);

  // Function to recalculate slider parameters
  function recalculateSliderParams() {
    const slideCount = $slider.find('.slick-slide:not(.slick-cloned)').length;
    const slidesToShow = $slider.find('.slick-active').length || 1;
    return {
      slideCount,
      slidesToShow,
      maxSlideIndex: Math.max(0, slideCount - slidesToShow),
    };
  }

  // Initial calculation
  let { slideCount, slidesToShow, maxSlideIndex } = recalculateSliderParams();

  const $sliderTrack = $slider
    .next('.slider-range-container')
    .find('.ui-slider');
  const $handle = $sliderTrack.find('.ui-slider-handle');
  const $range = $sliderTrack.find('.ui-slider-range');

  // Set initial handle position
  $handle.css('left', '0%');
  $range.css('width', '0%');

  // Variables to track dragging state
  let isDragging = false;
  let currentSlide = 0;
  let targetSlide = 0;
  let animationFrame = null;

  // Function to update visual display based on slide index
  function updateSliderVisuals(slideIndex) {
    // Recalculate maxSlideIndex to ensure it's current
    const { maxSlideIndex: currentMaxSlideIndex } = recalculateSliderParams();
    const percent =
      currentMaxSlideIndex > 0 ? (slideIndex / currentMaxSlideIndex) * 100 : 0;
    $handle.css('left', `${percent}%`);
    $range.css('width', `${percent}%`);
  }

  // Performance optimization: Use requestAnimationFrame for smoother dragging
  function throttledUpdate(e) {
    if (!animationFrame) {
      animationFrame = requestAnimationFrame(() => {
        updatePositionFromEvent(e);
        animationFrame = null;
      });
    }
  }

  // Make handle draggable with accessibility
  $handle.on('mousedown touchstart', function (e) {
    e.preventDefault();
    startDragging(e);
  });

  // Make track clickable too
  $sliderTrack.on('mousedown touchstart', function (e) {
    // Only handle direct clicks on the track (not on the handle)
    if ($(e.target).hasClass('ui-slider-handle')) return;

    e.preventDefault();
    startDragging(e);
    updatePositionFromEvent(e);
  });

  function startDragging(e) {
    isDragging = true;
    $handle.addClass('ui-state-active');

    // Prevent text selection while dragging
    $(document).on('selectstart.slider', function () {
      return false;
    });

    $('body').addClass('slider-dragging');
  }

  // Track mouse/touch movement with performance optimization
  $(document).on('mousemove touchmove', function (e) {
    if (!isDragging) return;
    throttledUpdate(e);
  });

  // Handle drag end
  $(document).on('mouseup touchend', function () {
    if (!isDragging) return;

    // Cancel any pending animation frame
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }

    // Ensure that the final visual position matches the target slide
    updateSliderVisuals(targetSlide);

    // If we've ended up at a different slide than the target, go to target
    if (currentSlide !== targetSlide) {
      $slider.slick('slickGoTo', targetSlide);
    }

    isDragging = false;
    $handle.removeClass('ui-state-active');
    $(document).off('selectstart.slider');
    $('body').removeClass('slider-dragging');
  });

  function updatePositionFromEvent(e) {
    const pageX = e.type.includes('touch')
      ? e.originalEvent.touches[0].pageX
      : e.pageX;
    const trackOffset = $sliderTrack.offset().left;
    const trackWidth = $sliderTrack.width();

    // Calculate position ratio (0 to 1)
    let ratio = (pageX - trackOffset) / trackWidth;
    ratio = Math.max(0, Math.min(1, ratio));

    // Get current max slide index
    const { maxSlideIndex: currentMaxSlideIndex } = recalculateSliderParams();

    // Calculate target slide (round to nearest integer for snapping)
    targetSlide = Math.round(ratio * currentMaxSlideIndex);

    // Update ARIA for accessibility
    $handle.attr('aria-valuenow', targetSlide);

    // Update visuals immediately for responsive feel
    updateSliderVisuals(targetSlide);

    // Only try to change slides if different from current
    if (targetSlide !== currentSlide) {
      $slider.slick('slickGoTo', targetSlide);
    }
  }

  // Update slider visuals BEFORE the slide changes (for arrow navigation)
  $slider.on(
    'beforeChange',
    function (event, slick, currentSlideIndex, nextSlideIndex) {
      // Only update if we're not currently dragging
      if (!isDragging) {
        updateSliderVisuals(nextSlideIndex);
        targetSlide = nextSlideIndex;
        $handle.attr('aria-valuenow', nextSlideIndex);
      }
    }
  );

  // Update internal tracking AFTER the slide changes
  $slider.on('afterChange', function (event, slick, newSlide) {
    currentSlide = newSlide;

    // If we're not dragging, ensure visuals match current slide
    if (!isDragging) {
      updateSliderVisuals(currentSlide);
      targetSlide = currentSlide;
      $handle.attr('aria-valuenow', currentSlide);
    }
  });

  // Listen for breakpoint changes
  $slider.on('breakpoint', function (event, slick, breakpoint) {
    // Recalculate parameters when breakpoint changes
    const newParams = recalculateSliderParams();
    slideCount = newParams.slideCount;
    slidesToShow = newParams.slidesToShow;
    maxSlideIndex = newParams.maxSlideIndex;

    // Update visuals to match current position with new parameters
    updateSliderVisuals(currentSlide);
  });

  // Set initial position
  updateSliderVisuals(currentSlide);
};

export const ProductSamplesMobileSliderSettings = () => {
  /**
   * Define Slick Slider Settings
   * This slider is used within the sample-form.js file
   * To display the Sample Product Cards within a slider on mobile devices
   **/
  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 992,
        settings: 'unslick',
      },
    ],
  };
  return sliderSettings;
};

export default () => {
  $(document).ready(function () {
    const imageCarousel = $('.image-carousel__slider');
    initImageCarouselSlider(imageCarousel);

    $('.single-item').slick();

    $('.single-panel').slick({
      dots: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $('.single-panel_no-dots').slick({
      dots: false,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $('.three-item-carousel').slick({
      infinite: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });

    $('.multiple-items').slick({
      dots: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $('.multiple-items_no-dots').slick({
      dots: false,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $('.multiple-items__product-slider').each(function () {
      const arrowContainer = $(this)
        .closest('.product-showcase')
        .find('.product-showcase__header-arrows');

      $(this).slick({
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        appendArrows: arrowContainer,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    });

    $('.product-showcase-slider')
      .on('init', function () {
        $(this).find('.slick-prev.slick-arrow').addClass('fade-out');
      })
      .on('afterChange', function (event, slick, currentSlide) {
        if (slick.options.slidesToShow > 1) {
          updateSliderArrowAppearance(
            'prev-arrow',
            $(this),
            slick,
            currentSlide
          );
          updateSliderArrowAppearance(
            'next-arrow',
            $(this),
            slick,
            currentSlide
          );
        }
      })
      .slick({
        dots: false,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

    $('.product-showcase-slider-progress')
      .on('init', function () {
        $(this).find('.slick-prev.slick-arrow').addClass('fade-out');

        setTimeout(() => {
          initProgressBar(this);
        }, 100);
      })
      .on('beforeChange', function (event, slick, currentSlide) {
        if (slick.options.slidesToShow > 1) {
          updateSliderArrowAppearance(
            'prev-arrow',
            $(this),
            slick,
            currentSlide
          );
          updateSliderArrowAppearance(
            'next-arrow',
            $(this),
            slick,
            currentSlide
          );
        }
      })
      .slick({
        dots: false,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
  });
};
